import {Directive, ElementRef, HostListener, OnInit, Renderer2, inject} from '@angular/core';
import {LanguageService} from '../services/language.service';
import {ApiService} from '../services/api.service';
import {EnvironmentService} from '../services/environment.service';

@Directive({
  selector: '[appTranslate]',
  standalone: true
})
export class TranslateDirective implements OnInit {
  private el: ElementRef = inject(ElementRef);
  private renderer: Renderer2 = inject(Renderer2);
  private languageService: LanguageService = inject(LanguageService);
  private apiService: ApiService = inject(ApiService);
  private environmentService: EnvironmentService = inject(EnvironmentService);

  private editable: boolean = this.environmentService.getEditing();
  private text: string = '';

  public ngOnInit(): void {
    this.environmentService.editing.subscribe(editable => {
      this.editable = editable;

      this.text = this.el.nativeElement.innerText.replace(':', '');
      const translated = this.languageService.getTranslationByKey(this.text);

      if (translated === this.text && editable) {
        this.renderer.setStyle(this.el.nativeElement, 'cursor', 'pointer');
        this.renderer.setStyle(this.el.nativeElement, 'border-bottom', '1px dashed gray');
      } else {
        this.renderer.setStyle(this.el.nativeElement, 'cursor', 'default');
        this.renderer.setStyle(this.el.nativeElement, 'border-bottom', 'none');
      }
    });
  }

  public save(key: string, value: string): void {
    this.apiService.setLanguageByKey(key, value).subscribe({
      next: () => {
        console.log('Done');
      }, error: (error) => {
        console.log(error);
      }
    });
  }

  @HostListener('click')
  public onClick(): void {
    if (this.editable) {
      this.text = this.el.nativeElement.innerText.replace(':', '');
      const newValue = prompt("Übersetzung für " + this.text + " ändern", this.el.nativeElement.innerText.replace(':', ''));
      if (newValue !== this.text && newValue !== null) {
        this.save(this.text, newValue);
        this.renderer.setProperty(this.el.nativeElement, 'innerText', newValue);
      }
    }
  }
}
